import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
 //import { config } from '../Common/WebConfig';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthToken } from '../Models/AuthToken.model';
declare var config;
@Injectable()
export class CommonService {
  ipAddress: any;
  ip: string;
  private actionUrl: string;
  private GetIPUrl: string;
  Userinfo: any;
  TokenData : AuthToken;
  constructor(private http: Http, private _router: Router,
    private activatedRoute: ActivatedRoute) {
    this.actionUrl = config.WebApiPath;
      this.GetIPUrl = config.GetIPUrl;
      
      this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
  }

  getIpAddress() {

    var IpAddress= JSON.parse(sessionStorage.getItem('IpAddress'));
    if(IpAddress===null || IpAddress===undefined){
  IpAddress=  this.http.get(this.GetIPUrl)
        .toPromise()
        .then(response =>  response.json())
        .catch(this.handleErrorPromise);


        sessionStorage.setItem('IpAddress', IpAddress.toString());

        return IpAddress;
    }
    else{
      return IpAddress
    }
      // .map(res => res.json())
      // .subscribe(data => {
      //   this.ipAddress = data.ip;
      // })
    
   
  }

  Get(url: string): Promise<any> {
   
    
    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
      'UserID': JSON.parse(sessionStorage.getItem('userinfo')).UserID,
    });

    const options = new RequestOptions({headers: headers});
    return this.http.get(this.actionUrl + url, options)
      .toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }


  GetDataWithParameter(strbody: string, url: string): Promise<any> {
    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
    
    if (this.TokenData === undefined || this.TokenData === null) {
      console.log('Tokendata is null or undefined')
      this._router.navigate(['/login']);
    }
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
      'EnterPrisePartnerID':JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,
      'CacheManagerID': JSON.parse(sessionStorage.getItem('userinfo')).CacheManagerID,
      'UserID': JSON.parse(sessionStorage.getItem('userinfo')).UserID,
    });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.actionUrl + url + '/' + strbody, options)
      .toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  PostLogin(strbody: any, url: string) {
    
    const headers = new Headers({
      // 'Content-Type': 'application/json', 
     
    }); 
    const options = new RequestOptions({headers: headers});
    const body = strbody;

    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  PostTrackIP(strbody: any, url: string) {
    
    const headers = new Headers({
      'Content-Type': 'application/json', 
      'EnterPrisePartnerID':JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,  
    });
    const options = new RequestOptions({headers: headers});
    const body = strbody;

    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  PostToken(strbody: any,url: string): Promise<any> {
    const body =  'grant_type=password&Username=' + strbody.Username + '&Password=' + strbody.Password + '';
    const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.actionUrl + url, body, options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  PostPartner(strbody: any, url: string) {
    //this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
    // if (this.TokenData === undefined || this.TokenData === null) {
    //   console.log('Tokendata is null or undefined')
    //   this._router.navigate(['/login']);
    // }
    const headers = new Headers({
      'Content-Type': 'application/json',
     // 'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
       'EnterPrisePartnerID':strbody.EnterprisePartnerID,
       'CacheManagerID': 1, 
     //  'UserID': JSON.parse(sessionStorage.getItem('userinfo')).UserID,
    });

    const options = new RequestOptions({headers: headers});
    const body = strbody;
    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  
  Post(strbody: any, url: string) {
    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
    // if (this.TokenData === undefined || this.TokenData === null) {
    //   console.log('Tokendata is null or undefined')
    //   this._router.navigate(['/login']);
    // }

    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
      'UserID': JSON.parse(sessionStorage.getItem('userinfo')).UserID,
    });

    const options = new RequestOptions({headers: headers});
    const body = strbody;
    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  protected extractArray(res: Response, showprogress: boolean = true) {
    const data = res.json();
    return data || [];
  }

  private handleErrorPromise(error: Response | any) {
    
    return Promise.reject(error.message || error);
  }

  public luhncheck(value): boolean {
    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm. It's so pretty.
    var nCheck = 0, nDigit = 0, bEven = false;
    value = value.replace(/\D/g, "");

    for (var n = value.length - 1; n >= 0; n--) {
      var cDigit = value.charAt(n),
        nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return (nCheck % 10) == 0;
  }


  MCheck(url: string): Promise<any> {
     
    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Accept': 'application/json',
      'Authorization': sessionStorage.getItem('AuthorizationType') + ' ' + sessionStorage.getItem('AuthorizationKey'),
      'EnterPrisePartnerID':JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,
    });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.actionUrl + url, options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  gettoken(url: string, model: any): Promise<any> {
     
    const body = 'grant_type=password&username=SuperUser&password=localhost';
    const headers = new Headers({ 
      'Content-Type': 'application/x-www-form-urlencoded',
       'Accept': 'application/json',
       'EnterPrisePartnerID':JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,
    
    });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  public GetValue(): Promise<any> {
    
    return this.http.get(`assets/Template/CAUK/OrderSuccessMail.html?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
    // this.http.get('assets/Template/CAUK/OrderSuccessMail.html').subscribe(data => {
    //   console.log(data.text());
    //   return data.text(); 
  }
  public OrderContractHtml(): Promise<any> {
    
    return this.http.get(`assets/Template/CAUK/OrderContract.html?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
  }
  public BoxDetailsHtml(): Promise<any> {
    
    return this.http.get(`assets/Template/CAUK/BoxDetails.html?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
  }
  public BagCloseOrders(): Promise<any> {
    
    return this.http.get(`assets/Template/CAUK/CloseBagOrders.html?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
  }


  public GetImage(ImageType:string,partnercode:string,DeviceModelID:string): Promise<any> {
    if(ImageType==='partnerlogo'){
      return this.http.get(`assets/PartnerLogo/CAUK/logo.png?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
    }
    else if(ImageType==='celldelogo'){
      return this.http.get(`assets/img/logo.png?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
    }
    else if(ImageType==='tradeddeviceimage'){
      return this.http.get(`assets/img/samsung-mobile.jpg?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
    }
    
   
  }


 clearStorageWithoutLogin(){
this.Userinfo = JSON.parse(sessionStorage.getItem('user'));
this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
sessionStorage.clear();
sessionStorage.setItem('userinfo', JSON.stringify(this.Userinfo));
sessionStorage.setItem('user',JSON.stringify(this.Userinfo));
sessionStorage.setItem('Token', JSON.stringify(this.TokenData));
  }

  
  getgrade(url: string): Promise<any> {
    var _token = sessionStorage.getItem('AccessToken');
    const headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options = new RequestOptions({
      headers: headers
    });
    return this.http.get(this.actionUrl + url, options)
      .toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  getData(strbody: any, url: string) {
    var _token = sessionStorage.getItem('AccessToken');
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'bearer ' + _token + '',
      'EnterPrisePartnerID': strbody.EnterprisePartnerID,
      CacheManagerID: 1,
    });
    const options = new RequestOptions({
      headers: headers
    });
    const body = strbody;
    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  getPhoneData(strbody: any, url: string) {
    debugger;
    var _token = sessionStorage.getItem('AccessToken');
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'bearer ' + _token + ''
    });
    const options = new RequestOptions({
      headers: headers
    });
    const body = strbody;
    return this.http.post(this.actionUrl+ url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }



}
